import type { HttpGet, HttpRequest } from '@/shared/infra/http'
import type { LegalDocument } from '@/modules/legal/domain'
import type { LoadCurrentDocument } from '@/modules/legal/use-cases'

export class EdgeLoadCurrentDocumentRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadCurrentDocument = async ({ documentType }) => {
    const url = `/legal-documents/current?documentType=${encodeURIComponent(documentType)}`
    const request: HttpRequest<never> = { url }
    const response = await this.httpClient.get<{ document?: LegalDocument | null }>(request)
    return response.document ?? null
  }
}
